import { FrontendAPIHelper } from '../../FrontendAPIHelper';
import { BIM360Modelset } from '../BIM360Modelset';
import { PaginationRequest } from '../../util/PaginationParameters';

const api = new FrontendAPIHelper();

class FrontendPatchModelsetResponse {

}

export class FrontendBIM360Modelset extends BIM360Modelset
{
    public clone!: any;
    public hubID = "";
    public projectID = "";
    constructor() {
        super();
    }

    public cloneMe() {
        this.clone = {...this};
      }

    public async saveChanges()
    {
        const pagination = new PaginationRequest();
        let payload = {
            newName: (this.name != this.clone.name) ? this.name : undefined,
            oldName: (this.name != this.clone.name) ? this.clone.name : undefined,
            newDescription: (this.description != this.clone.description) ? this.description : undefined,
            oldDescription: (this.description != this.clone.description) ? this.clone.description : undefined,
        };
        let result = await api.callEndpoint(FrontendPatchModelsetResponse, 'PATCH', `/hubs/${this.hubID}/containers/${this.projectID}/modelsets/${this.id}`, pagination, {modelset: payload});
    }

    public saveChangesPromise() : Promise<any>
    {
        let payload = {
            newName: (this.name != this.clone.name) ? this.name : undefined,
            oldName: (this.name != this.clone.name) ? this.clone.name : undefined,
            newDescription: (this.description != this.clone.description) ? this.description : undefined,
            oldDescription: (this.description != this.clone.description) ? this.clone.description : undefined,
        };
        return api.callEndpoint(FrontendPatchModelsetResponse, 'PATCH', `/hubs/${this.hubID}/containers/${this.projectID}/modelsets/${this.id}`, PaginationRequest.noPagination(), {modelset: payload});
    }

    public isUpdated() {
        if(this.clone && (this.name !== this.clone.name) || (this.description !== this.clone.description)) return true;
        return false;
    }

    public isPropertyUpdated(property: string) {
        if(this.clone && (this[property] !== this.clone[property])) return true;
        return false;
    }

}
